export const VENUE_CONTACTS_RECORD_KEY = 'contacts';

export interface VenueContactType {
    name: string;
    type: string;
    organization: string;
    email: string;
    phone: string;
}
